import { render, staticRenderFns } from "./button.vue?vue&type=template&id=43b3f6fe&scoped=true&"
import script from "./button.vue?vue&type=script&lang=ts&"
export * from "./button.vue?vue&type=script&lang=ts&"
import style0 from "./button.vue?vue&type=style&index=0&id=43b3f6fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3f6fe",
  null
  
)

export default component.exports